module.exports = __webpack_public_path__ + "static/media/DGAC_Dashboard_Page_Header_mobile.03012326.jpg";